import { css } from "@emotion/react";
import { useTailwindMediaQueries } from "@/hooks/useTailwindMediaQueries";
import type { ImmutableObject } from "@/lib/immutable";
import type { PackageItem, Product } from "../../../hooks/useInventoryState";
import { useShoppingCartItemsState } from "../../../hooks/useShoppingCartItemsState";
import FwFunc from "../../../lib/FwReact/FwFunc";
import { FwNumberDropDown } from "../../../lib/FwReact/FwNumberDropDown";
import { ShoppingCartPackageItemAvailability } from "../PackageItemFields/ShoppingCartPackageItemAvailability";
import type { ShoppingCartViewSettings } from "../ShoppingCartControl";

//------------------------------------------------------------------------------------
export type ShoppingCartPackageItemOptionalDesktopProps = {
	packageProduct: ImmutableObject<Product>;
	packageItem: ImmutableObject<PackageItem>;
	enableQty: boolean;
	viewSettings: ShoppingCartViewSettings;
};
export const ShoppingCartPackageItemOptionalDesktop: React.FC<
	ShoppingCartPackageItemOptionalDesktopProps
> = (props) => {
	const mediaQueries = useTailwindMediaQueries();
	const packageProduct = props.packageProduct;
	const isAvailable = (packageProduct.Availability?.TotalIn ?? 0) > 0;
	const canAddToCart =
		props.enableQty &&
		(isAvailable || props.viewSettings.allowAddingUnavailableItems);
	const item = props.packageItem;
	const shoppingCartItemsState = useShoppingCartItemsState();
	const showAvailability = item.Availability !== undefined;
	const showDailyRate =
		mediaQueries.tablet &&
		props.viewSettings.hasRates &&
		props.viewSettings.hasDailyRate;
	const showWeeklyRate =
		mediaQueries.tablet &&
		props.viewSettings.hasRates &&
		props.viewSettings.hasWeeklyRate;
	const showMonthlyRate =
		mediaQueries.tablet &&
		props.viewSettings.hasRates &&
		props.viewSettings.hasMonthlyRate;

	const handleChangeQtyAsync = async (value: number): Promise<void> => {
		return Promise.resolve().then(() => {
			shoppingCartItemsState.setPackageItemQty(
				props.packageProduct,
				props.packageItem,
				value,
			);
		});
	};
	const maxQty = shoppingCartItemsState.getMaxPackageItemQty(
		packageProduct,
		props.packageItem,
	);
	return (
		<tr className="packageitemrow">
			<td className="col-legend"></td>
			<td className="col-description">{item.Description}</td>
			{(canAddToCart || showAvailability) && (
				<td className="col-qty">
					{canAddToCart && (
						<FwNumberDropDown
							css={css`flex:1 1 0;`}
							value={shoppingCartItemsState.getPackageItemQty(
								props.packageProduct,
								item,
							)}
							maxQty={maxQty}
							onChange={(newValue) => {
								handleChangeQtyAsync(newValue);
							}}
						/>
					)}
					{showAvailability && (
						<ShoppingCartPackageItemAvailability packageItem={item} />
					)}
				</td>
			)}

			{showDailyRate && (
				<td className="col-dailyrate">
					<span className="CurrencySymbol">{item.CurrencySymbol}</span>
					<span className="Price">
						{FwFunc.numberFormatter(item.DailyRate, 2, ",", ".")}
					</span>
				</td>
			)}

			{showWeeklyRate && (
				<td className="col-weeklyrate">
					<span className="CurrencySymbol">{item.CurrencySymbol}</span>
					<span className="Price">
						{FwFunc.numberFormatter(item.WeeklyRate, 2, ",", ".")}
					</span>
				</td>
			)}

			{showMonthlyRate && (
				<td className="col-monthlyrate">
					<span className="CurrencySymbol">{item.CurrencySymbol}</span>
					<span className="Price">
						{FwFunc.numberFormatter(item.MonthlyRate, 2, ",", ".")}
					</span>
				</td>
			)}

			{false && showAvailability && (
				<td className="col-availability">
					<ShoppingCartPackageItemAvailability packageItem={item} />
				</td>
			)}
		</tr>
	);
};
